import styled from '@emotion/native';
import { Col } from 'components/base';
import { Card, ToggleButton } from 'design-system';
import React, { useCallback } from 'react';

type Option<TLink extends string> = {
  value: TLink;
  display: string;
};

interface ToggleProps<TLink extends string> {
  active: TLink;
  options: Option<TLink>[];
  navigate: (link: TLink) => void;
  children?: React.ReactNode;
}

const ToggleWrapper = styled(Col)(({ theme }) => ({
  backgroundColor: theme.color['base-grey'],
  justifyContent: 'center',
  alignItems: 'center',
}));

export const NavigationToggle = <TLink extends string>({
  active,
  options,
  navigate,
  children,
}: ToggleProps<TLink>): React.ReactElement => {
  const onChange = useCallback(
    (value: TLink) => {
      if (value === active) {
        return;
      }

      navigate(value);
    },
    [active, navigate]
  );

  return (
    <Card unsetZIndex>
      <ToggleWrapper>
        <Col alignItems="center" justifyContent="center">
          <ToggleButton<TLink> onChange={onChange} options={options} value={active} />
        </Col>
      </ToggleWrapper>
      {children}
    </Card>
  );
};
